import { render } from "./DisplayClosedProject.vue?vue&type=template&id=e0e3fd10"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__